module.exports = __webpack_public_path__ + "media/images/logo_majorelle_mobility-f0431a19080b34fde136886e8fce094c.png";